<template>
    <div class="serverWrap flexCol left">
        <div class="serverTop bgcScW">
            <div class="selectCampusBox fontH3 fontScN7 rowAc" @click="selectCampus">
                当前机构 <div class="line"></div> {{selectedCampus.campusName}}
            </div>
            <div>
                <img src="../../assets/static/index/banner.svg" alt="" class="bannerImg">
            </div>
            
        </div>
        <div class="serverSection bgcScW">
            <div class="funList flexRow">
                <div class="funItemBox colAc" v-for="(item,index) in btnShowList" :key="index">
                        <img :src="item.img" alt="" class="funImg" @click="jumpFunPage(item.path)">
                        <div class="fontH4 fontScN7" @click="jumpFunPage(item.path)">{{item.name}}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getPermissionListAPI } from "../../utils/api/api";
export default {
    data() {
        return {
            institutionCode: '',  //机构code
            permissionList: [],  //权限按钮列表
            btnShowList: [],
            funList: [
                {img: require('../../assets/static/index/courseList.svg'),name: '课程表',path: '/courseList'},
                {img: require('../../assets/static/index/checkIn.svg'),name: '考勤记录',path: '/checkIn'},
                {img: require('../../assets/static/index/classhourRecord.svg'),name: '课时记录',path: '/classhourRecord'},
                {img: require('../../assets/static/index/task.svg'),name: '作业练习',path: '/taskList'},
                {img: require('../../assets/static/index/vacate.svg'),name: '请假停课',path: '/vacateClose'},
                {img: require('../../assets/static/index/business.svg'),name: '办理记录',path: '/record'},
                {img: require('../../assets/static/index/readCourse.svg'),name: '在读课程',path: '/currentCourse'},
                {img: require('../../assets/static/index/courseReview.svg'),name: '课堂点评',path: '/courseReview'},
                {img: require('../../assets/static/index/distinction.svg'),name: '专业考级',path: '/professionalExam'},
                {img: require('../../assets/static/index/orderCourse.svg'),name: '预约上课',path: '/bookCourse'},
                {img: require('../../assets/static/index/signContract.svg'),name: '合同签署',path: '/contractList'},
                {img: require('../../assets/static/index/mendLesson.svg'),name: '学员待补课',path: '/mendLesson'},
            ],
            selectedCampus: {},
            isRealName:'',//是否实名认证
        }
    },
    
    created() {
        this.institutionCode = JSON.parse(this.$common.getCache("customerInfo")).institutionCode; //获取校区code
        console.log("获取校区code", this.institutionCode);
        if(this.institutionCode) {
            this.getBtnShow()
        }
        if(this.$common.getCache('customerAuthList')) {
            var campusList = JSON.parse(this.$common.getCache('customerAuthList'))
            if(campusList && campusList.length != 0) {
                var idx = campusList.findIndex(item => {return item.campusCode == JSON.parse(this.$common.getCache("customerInfo")).campusCode})
                this.selectedCampus = idx == '-1' ? campusList[0] : campusList[idx]
                this.$common.setCache('campusItem',idx == '-1' ? JSON.stringify(campusList[0]) : JSON.stringify(campusList[idx]))
            }
        }else {
            this.selectedCampus = JSON.parse(this.$common.getCache("customerInfo"))
            this.$set(this.selectedCampus,'campusName',this.selectedCampus.institutionName+'-'+this.selectedCampus.campusName)
            this.$common.setCache('campusItem',JSON.stringify(this.selectedCampus))
        }
        
        // if(this.$common.getCache('campusItem') && campusList && campusList.length) { // 判断本地有无校区信息
        //     this.selectedCampus = JSON.parse(this.$common.getCache('campusItem'))
        // }else {
            
        //     if(campusList && campusList.length != 0) {
        //         var idx = campusList.findIndex(item => {return item.campusCode == JSON.parse(this.$common.getCache("customerInfo")).campusCode})
        //         this.selectedCampus = idx == '-1' ? campusList[0] : campusList[idx]
        //         this.$common.setCache('campusItem',idx == '-1' ? JSON.stringify(campusList[0]) : JSON.stringify(campusList[idx]))
        //     }
        // }
        if(this.$common.getCache('isRealName')){
            this.isRealName = this.$common.getCache('isRealName')
        }
        
    },
    methods: {
        jumpFunPage(path) {
            if(path == '/contractList' && this.isRealName!= 1){
                this.$router.push('/authenticationMode')
            }else{
                this.checkBuried(path)
                this.$router.push(path)
            }
            
        },
        // 埋点判断
        checkBuried(path){
            if(path == '/courseList'){
                this.$common.buriedFun('20001001')
            }else if(path == '/checkIn'){
                this.$common.buriedFun('20002001')
            }else if(path == '/taskList'){
                this.$common.buriedFun('20003001')
            }else if(path == '/vacateClose'){
                this.$common.buriedFun('20004001')
            }else if(path == '/record'){
                this.$common.buriedFun('20005001')
            }else if(path == '/currentCourse'){
                this.$common.buriedFun('20006001')
            }else if(path == '/courseReview'){
                this.$common.buriedFun('20007001')
            }else if(path == '/professionalExam'){
                this.$common.buriedFun('20008001')
            }else if(path == '/bookCourse'){
                this.$common.buriedFun('20009001')
            }else if(path == '/contractList'){
                this.$common.buriedFun('20010001')
            } else if(path == '/classhourRecord'){
                this.$common.buriedFun('20011001')
            }else if(path == '/mendLesson'){
                this.$common.buriedFun('20012001')
            }
        },
        // 选择校区
        selectCampus() {
            this.$router.push('/changeInstitutions')
        },
        getBtnShow() {
            getPermissionListAPI().then(res => {
                var btnList = []
                this.permissionList = []
                if(res.resultCode == 200) {
                    btnList = res.data
                    this.btnShowList = this.funList.filter(item => btnList.some( item1 => {return item1.permissionName == item.name}))
                    console.log('得到的按钮列表', this.btnShowList)
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.serverWrap {
    width: 100%;
    height: 100%;
}
.serverTop {
    padding: .16rem;
    // padding-top: .16rem;
    // padding-bottom: .16rem;
    // width: 100%;
    margin-bottom: 12px;
    // padding: 4px 16px 16px;
}
.selectCampusBox {
    // width: 3.43rem;
    min-height: .37rem;
    padding: .08rem .14rem;
    border-radius: .19rem;
    box-sizing: border-box;
    border: 1px solid #122475;
    vertical-align: middle;
    margin-bottom: 16px;
}
.serverSection {
    flex: 1;
    overflow: hidden;
    border-radius: 16px 16px 0px 0px;
    box-sizing: border-box;
    padding: .24rem .1rem 0;
}
.funList {
    flex-wrap: wrap;
}
.funItemBox {
    width: 25%;
    margin-bottom: .2rem;
    .funImg {
        width: .4rem;
        margin-bottom: 2px;
    }
}
.line {
    height: .14rem;
    width: 1px;
    margin: 0 6px;
    background: #5A6073;
}
.bannerImg {
    // width: 3.34rem;
    width: 100%;
}
</style>